module.exports = __webpack_public_path__ + "img/Instagram-logo.56f60dec.svg";